// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `[dir] .wrapper--sfv99 {
  padding: 30px 60px;
}

[dir] .forGraph--y8Lcf {
  margin-top: -70px;
}

[dir=ltr] .infoIcon--TTON7 {
  margin-left: 5px;
}

[dir=rtl] .infoIcon--TTON7 {
  margin-right: 5px;
}

.trendsCell--lpJw8 {
  width: 100%;
}

[dir=ltr] .infoIcon--TTON7 {
  margin-left: 5px;
}

[dir=rtl] .infoIcon--TTON7 {
  margin-right: 5px;
}

.fadeTrend--JTeVU {
  opacity: 0.25;
}

.trendsIncreasingImprovement--HdM9n {
  color: white;
}

[dir] .trendsIncreasingImprovement--HdM9n {
  background-color: #418a8f;
}

[dir] .trendsSlowingImprovement--FWzGT {
  background-color: #89a361;
}

[dir] .trendsWarningSigns--rSc0E {
  background-color: #c5b300;
}

[dir] .trendsBouncingBack--Tuh__ {
  background-color: #ffd500;
}

[dir] .trendsSlowingDeterioration--AwhJY {
  background-color: #ee7330;
}

.trendsIncreasingDeterioration--pZatv {
  color: white;
}

[dir] .trendsIncreasingDeterioration--pZatv {
  background-color: #b1302e;
}
`, "",{"version":3,"sources":["webpack://./src/js/components/MapLegend/subComponents/TrendsLegend/styles.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;AAClB;;AAFA;EACE,iBAAgB;AAClB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,gBAAgB;AAClB;;AAFA;EACE,iBAAgB;AAClB;;AAEA;EACE,aAAa;AACf;;AAEA;EAEE,YAAY;AACd;;AAHA;EACE,yBAAyB;AAE3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EAEE,YAAY;AACd;;AAHA;EACE,yBAAyB;AAE3B","sourcesContent":[".wrapper {\n  padding: 30px 60px;\n}\n\n.forGraph {\n  margin-top: -70px;\n}\n\n.infoIcon {\n  margin-left: 5px;\n}\n\n.trendsCell {\n  width: 100%;\n}\n\n.infoIcon {\n  margin-left: 5px;\n}\n\n.fadeTrend {\n  opacity: 0.25;\n}\n\n.trendsIncreasingImprovement {\n  background-color: #418a8f;\n  color: white;\n}\n\n.trendsSlowingImprovement {\n  background-color: #89a361;\n}\n\n.trendsWarningSigns {\n  background-color: #c5b300;\n}\n\n.trendsBouncingBack {\n  background-color: #ffd500;\n}\n\n.trendsSlowingDeterioration {\n  background-color: #ee7330;\n}\n\n.trendsIncreasingDeterioration {\n  background-color: #b1302e;\n  color: white;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"wrapper": `wrapper--sfv99`,
	"forGraph": `forGraph--y8Lcf`,
	"infoIcon": `infoIcon--TTON7`,
	"trendsCell": `trendsCell--lpJw8`,
	"fadeTrend": `fadeTrend--JTeVU`,
	"trendsIncreasingImprovement": `trendsIncreasingImprovement--HdM9n`,
	"trendsSlowingImprovement": `trendsSlowingImprovement--FWzGT`,
	"trendsWarningSigns": `trendsWarningSigns--rSc0E`,
	"trendsBouncingBack": `trendsBouncingBack--Tuh__`,
	"trendsSlowingDeterioration": `trendsSlowingDeterioration--AwhJY`,
	"trendsIncreasingDeterioration": `trendsIncreasingDeterioration--pZatv`
};
export default ___CSS_LOADER_EXPORT___;
